<template>
  <div class="logistic-map">
    <!-- 배경 그림 -->
    <img :src="backgroundImage" alt="Logistics Background" class="map-background" />

    <!-- 각 연결선: 점선과 실선을 5초마다 변경 -->
    <div
      v-for="(route, index) in routes"
      :key="index"
      class="line-container"
    >
      <div
        :class="['line', route.isDashed ? 'dashed' : 'solid']"
        :style="getLineStyle(route)"
        @click="navigateToLink(route)"
      ></div>
      <!-- 선 끝에 고정된 화살표 아이콘 -->
     
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backgroundImage: require('@/assets/logistics-background.png'), // 배경 이미지 경로
      routes: [
        {
          start: { x: -650, y: -100 }, // Warehouse A 좌표
          end: { x: -550, y: 0 }, // Logistics warehouse 좌표
          isDashed: true,
          dashedLink: 'https://www.google.com/maps/d/u/0/edit?mid=1hbB5H3F_eJFyxmFS9kChLbgJvByOWH8&usp=sharing',
          solidLink: 'https://www.google.com/maps/d/u/0/edit?mid=1Wt-NyaXjvOJH-RwvQTDLQPjS2A9zJYY&usp=sharing',
        },
        {
          start: { x: -650, y: 150 }, // Warehouse B 좌표
          end: { x: -550, y: 0 }, // Logistics warehouse 좌표
          isDashed: true,
          dashedLink: 'https://www.google.com/maps/d/u/0/edit?mid=16eV-ukXNBNCDVPm9obLkdae-SlP6uW8&usp=sharing',
          solidLink: 'https://www.google.com/maps/d/u/0/edit?mid=1x36fjH1vPxdaBIkbv7GtkU0k4R_GFoQ&usp=sharing',
        },
        {
          start: { x: -250, y: 0 }, // Logistics warehouse 좌표
          end: { x: -120, y: 0 }, // Destination warehouse 좌표
          isDashed: true,
          dashedLink: 'https://www.google.com/maps/d/u/0/edit?mid=1PXKgAMQCLJK8xVeCscjJfwhi-sHbi3w&usp=sharing',
          solidLink: 'https://www.google.com/maps/d/u/0/edit?mid=17DBvjs177n5jp2EXS6ac0oXvItZcmfU&usp=sharing',
        },
        {
          start: { x: 100, y: -100 }, // Destination warehouse 좌표
          end: { x: 250, y: -200 }, // Store 좌표
          isDashed: true,
          dashedLink: 'https://www.google.com/maps/d/u/0/edit?mid=1IQZ5emylwQca5Appaqad-xIBbr6h1wk&usp=sharing',
          solidLink: 'https://www.google.com/maps/d/u/0/edit?mid=1ucDdFifBcDxVaKUiL50XE5TC-uqIaBw&usp=sharing',
        },
        {
          start: { x: 120, y: 100 }, // Destination warehouse 좌표
          end: { x: 250, y: 150 }, // Local Shop 좌표
          isDashed: true,
          dashedLink: 'https://www.google.com/maps/d/u/0/edit?mid=1aQfsYO1u_WY0zVeJjWffkTu9e-i8fXI&usp=sharing',
          solidLink: 'https://www.google.com/maps/d/u/0/edit?mid=10iq4WEh4sdizbTGp4qPWa36IZ7yucTk&usp=sharing',
        },
      ],
    };
  },
  mounted() {
    // 5초마다 선 스타일 변경
    setInterval(() => {
      this.routes.forEach(route => {
        route.isDashed = Math.random() >= 0.5; 
      });
    }, 5000);
  },
  methods: {
    getLineStyle(route) {
      const angle = Math.atan2(
        route.end.y - route.start.y,
        route.end.x - route.start.x
      );
      const length = Math.sqrt(
        Math.pow(route.end.x - route.start.x, 2) + Math.pow(route.end.y - route.start.y, 2)
      );

      return {
        position: 'absolute',
        top: `${route.start.y}px`,
        left: `${route.start.x}px`,
        width: `${length}px`,
        transform: `rotate(${angle}rad)`,
      };
    },
    getArrowStyle(route) {
      const angle = Math.atan2(
        route.end.y - route.start.y,
        route.end.x - route.start.x
      );

      return {
        position: 'absolute',
        top: `${route.end.y}px`,
        left: `${route.end.x}px`,
        transform: `translate(-50%, -50%) rotate(${angle}rad)`, // 중앙에서 회전하도록 조정
      };
    },
    navigateToLink(route) {
      const link = route.isDashed ? route.dashedLink : route.solidLink;
      window.open(link, '_blank');
    },
  },
};
</script>

<style scoped>
.logistic-map {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100vw - 350px); /* 사이드바가 있는 공간을 남겨둠 */
  height: 100vh;
  position: relative;
  pointer-events: none; /* 전체 클릭 차단 */
}

.map-background {
  width: 100%;
  max-width: 1500px;
  height: auto;
  margin-right: 350px;
}

.line-container {
  position: absolute;
}

.line {
  cursor: pointer;
  height: 4px;
  transition: all 0.5s;
  z-index: 1;
  pointer-events: auto;
}

.dashed {
  border-top: 4px dashed red;
}

.solid {
  border-top: 4px solid rgb(14, 203, 228);
}

/* 선 끝에 고정된 화살표 */

</style>
